import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './RankingsSelection.css';

const RankingsSelection = () => {
    const [selectedRankings, setSelectedRankings] = useState('');
    const navigate = useNavigate();

    const handleRankingsSelect = (rankings) => {
        setSelectedRankings(rankings);
    };

    const handleStartDraft = () => {
        if (selectedRankings) {
            sessionStorage.setItem('selectedRankings', selectedRankings);
            navigate('/draft');
        }
    };

    return (
        <div className="rankings-selection-container">
            <h1>Choose Rankings</h1>
            <div className="rankings-options">
                <div 
                    className={`rankings-box ${selectedRankings === 'consensus' ? 'selected' : ''}`}
                    onClick={() => handleRankingsSelect('consensus')}
                >
                    <div className="checkmark">{selectedRankings === 'consensus' ? '✓' : ''}</div>
                    <h2>Consensus Rankings</h2>
                </div>
                <div 
                    className={`rankings-box ${selectedRankings === 'jeffRisdon' ? 'selected' : ''}`}
                    onClick={() => handleRankingsSelect('jeffRisdon')}
                >
                    <div className="checkmark">{selectedRankings === 'jeffRisdon' ? '✓' : ''}</div>
                    <h2>Jeff Risdon Rankings</h2>
                </div>
            </div>
            <button 
                className="start-draft-button"
                onClick={handleStartDraft}
                disabled={!selectedRankings}
            >
                Ready to Draft?
            </button>
        </div>
    );
};

export default RankingsSelection;